(function ($) {
	$.fn.LightTextBox = function(options) {

		var designer = this;

		if (options !== "destroy") {

			var wrapperTextEl = $(".wrappertext", $(designer));
			var def = $(".welcomeTextForEditor", $(wrapperTextEl)).html();

			var source = wrapperTextEl.html();
			if (!source) source = $(designer).html();

			var currentBackgroundColor = wrapperTextEl.css("background-color");
			var currentBackgroundColorId = wrapperTextEl.attr("data-background-color-colorplaceholderid");
			var currentAlignVertical = wrapperTextEl.attr("data-align-vertical");
			var currentAutoResize = wrapperTextEl.attr("data-autoresize");
			var copystyles = !!wrapperTextEl.attr("data-copy-style");
			var isSlideTitle, isSlideSubtitle, isSlideFooter;

			$(designer).html("");
			$(designer).css("padding", "0");
			var statictext = $("<div id='statictext' class='DUISetupOuter'><div><textarea style='width:100%' id='content1' name='content1'></textarea></div></div>");
			statictext.toggleClass('statictext-storycreator', window.ContentType == Storyboard.Constants.itemTypes.CHART);
			statictext.appendTo($("body"));

			var width = $(this).width() - 1;
			var height = $(this).height();
			var top = $(this).offset().top - $(window).scrollTop() - 1;
			var left = $(this).offset().left - $(window).scrollLeft() - 1;

			left = Math.max(left, 0);

			var selectedLanguage = $("#ddlLng").val();

			var fonts = Storyboard.LayoutDesigner.getFonts();
			var fontFormats = "";
			for (var i = 0; i < fonts.length; i++) {
				var f = fonts[i];
				fontFormats += f.FallBackFont ? f.Name + "=" + f.Family + "," + f.FallBackFont + ";" : f.Name + "=" + f.Family + ";";
			}
			var defaultFont = Storyboard.LayoutDesigner.getDefaultFont();

			var toolbar = [
				"saveelement cancelcontent resetcontent | bold italic underline | textcolorpicker backgroundcolorpicker | userevents tokens copystyles",
				"alignleft aligncenter alignright alignjustify | aligntop alignmiddle alignbottom | autoresize | numlist bullist outdent indent | fontselect fontsizeselect"
			];

			if (window.ContentType == Storyboard.Constants.itemTypes.CHART) {
				isSlideTitle = wrapperTextEl.hasClass('slidetitletext');
				isSlideSubtitle = wrapperTextEl.hasClass('slidesubtitletext');
				isSlideFooter = wrapperTextEl.hasClass('slidefootertext');

				toolbar[0] = toolbar[0].replace('saveelement', '').replace('resetcontent', '');

				if (width > 800) {
					toolbar = toolbar.join(' | ');
				}

				statictext.unbind('click').bind('click', function(event) {
					if (event.target !== this) return;

					designer.removeEmptyElements();
					$(".saveEdit", ".layoutElementAdminFocused").click();
				});
			}

			designer.setDefaultContent = function() {
				var ed = tinyMCE.get("content1");

				if (!ed) return;

				ed.execCommand("FontName", false, defaultFont.Family);

				if (isSlideTitle) {
					ed.execCommand("mceAlignVertical", true, "middle");
					ed.execCommand("JustifyCenter", false, true);
					ed.execCommand('FontName', false, defaultFont.Family);
					ed.execCommand("FontSize", false, "16pt");
					ed.execCommand("Bold", false, true);
				} else if (isSlideSubtitle) {
					ed.execCommand("mceAlignVertical", true, "middle");
					ed.execCommand("JustifyCenter", false, true);
					ed.execCommand('FontName', false, defaultFont.Family);
					ed.execCommand("FontSize", false, "12pt");
				} else if (isSlideFooter) {
					ed.execCommand("mceAlignVertical", true, "middle");
					ed.execCommand("JustifyCenter", false, true);
					ed.execCommand('FontName', false, defaultFont.Family);
					ed.execCommand("FontSize", false, "10pt");
				} else {
					ed.execCommand("mceAlignVertical", false, "top");
					ed.execCommand("mceAlignVertical", false, "middle");
					ed.execCommand("mceAlignVertical", false, "bottom");
					ed.execCommand('FontName', false, defaultFont.Family);
					ed.execCommand('FontSize', false, "12pt");
				}
			}

			designer.removeEmptyElements = function() {
				var ed = tinyMCE.get('content1');

				// hack to remove empty <p> elements that are created by tinymce in some cases
				if (ed && ed.dom && ed.dom.doc && ed.dom.doc.body) {
					var content = $(ed.dom.doc.body);
					var $p = $(content).children('p');
					$p.each(function () {
						if ($(this).html().trim() === '')
							$(this).remove();
					});
				}
			}

			tinyMCE.init({
				mode: "exact",
				theme: "modern",
				skin : "dapresy",

				selector: "#content1",
				auto_focus: "content1",

				height: height,
				width: (width < 420 ? 420 : width),

				inline_styles: true,
				convert_fonts_to_spans: true,

				plugins: "alignvertical paste advlist lists backgroundcolorpicker textcolorpicker autoresize" +
					(window.IsStoryboard && !(window.ContentType > 0) ? " tokens" : "") +
					(window.IsStoryboard && !(window.ContentType > 0) ? " userevents" : "") +
					(selectedLanguage ? " copystyles" : ""),
				formats: {
					forecolor: {
						inline: 'span',
						classes: 'forecolor',
						styles: {color: '%value'},
						attributes: {'data-color-colorplaceholderid' : '%placeholderId'},
						links: true,
						remove_similar: true
					}
				},

				autoresize_on_init: true,
				autoresize_bottom_margin: 0,
				autoresize_overflow_padding: 0,

				fontname: defaultFont.Name,
				font_formats: fontFormats,

				fontsize_formats: "5pt 6pt 7pt 8pt 9pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 17pt 18pt 19pt 20pt 21pt 22pt 23pt 24pt 25pt 26pt 27pt 28pt 29pt 30pt 32pt 34pt 36pt 38pt 40pt 44pt 48pt 54pt 60pt 66pt 72pt 80pt 88pt 96pt 100pt",

				force_hex_style_colors: true,
				language: "",

				menubar: false,
				statusbar : false,
				toolbar: toolbar,
				paste_as_text: true,

				advlist_number_styles: "numbers,lower-alpha,lower-roman,upper-alpha,upper-roman",

				setup: function (ed) {
					ed.addButton("saveelement", {
						title: "Save",
						icon: "save",
						onclick: function () {
							designer.removeEmptyElements();
							$(".saveEdit", ".layoutElementAdminFocused").click();
						}
					});
					ed.addButton("cancelcontent", {
						title: "Cancel",
						icon: "remove",
						onclick: function () {
							$(".cancelEdit", ".layoutElementAdminFocused").click();
						}
					});
					ed.addButton("resetcontent", {
						title: "Reset Content",
						icon: "rotateleft",
						onclick: function () {
							$(".clearEdit", ".layoutElementAdminFocused").click();
						}
					});
					ed.on("init", function () {
						var content = "";
						var events = Storyboard.LayoutDesigner.UserEvents.getEventsOptions(designer);
						var body = ed.getBody();

						if (source && !def)
							content = source;

						if (!source || content.replace(/<[^>]+>/g, "") === "") {
							designer.setDefaultContent();
						} else {
							ed.setContent(content);
						}

						body.style.backgroundColor = currentBackgroundColor;

						if (currentBackgroundColorId)
							body.setAttribute('data-background-color-colorplaceholderid', currentBackgroundColorId);

						if (currentAlignVertical)
							body.setAttribute('data-align-vertical', currentAlignVertical);

						if (currentAutoResize)
							body.setAttribute('data-autoresize', currentAutoResize);

						ed.pasteAsPlainText = true;

						if (events && events.length > 0)
							$(".mce-btn[aria-label='Events']").addClass("mce-active");
						if (copystyles)
							$(".mce-btn[aria-label='" + locale.get("Copy text style to all languages") + "']").addClass("mce-active");

						$(".mce-tinymce.mce-container.mce-panel").css("background", "none");
						$(".mce-edit-area").css("background", "none");

						var totalHeight = $(tinyMCE.activeEditor.getContainer()).height();
						var contentHeight = $(tinyMCE.activeEditor.getContentAreaContainer()).height();
						var toolbarHeight = totalHeight - contentHeight;

						$(tinyMCE.activeEditor.getContainer()).parent().css({
							position: 'absolute',
							width: (width < 300 ? 300 : width),
							top: (top < 100 ? 100 : top) - toolbarHeight,
							left: left
						});

						$(tinyMCE.activeEditor.getContentAreaContainer()).find('> iframe').css({
							width: width,
							height: height
						});

						$(designer).hide().parent().hide(); // hide layout element

						// fire the old ExecCommand event on format change
						var oldApply = tinymce.activeEditor.formatter.apply;
						tinymce.activeEditor.formatter.apply = function apply(name, vars, node) {
							oldApply(name, vars, node);
							tinymce.activeEditor.fire('ExecCommand', {name: name, vars: vars});
						}

						ed.focus();
					});

					ed.on("mousedown", function() {
						$(ed.contentAreaContainer.parentElement).find(".colorpicker-target.active").DUIColorPicker('hide');
					});

					// fix for the broken dynamic text on backspace/delete issue
					ed.on('keyup', function (e) {
						if (e.keyCode == 8 || e.keyCode == 46) {
							var t = e.target;
							fixdynamictext(t.children);
						}
					});

					window.tinymceListNodesCheck(ed);
					window.firefoxArialBlack(ed);
				}
			});
			$(".clearEdit", $(this).parent()).unbind('click').bind("click", function () {
				designer.setDefaultContent();
			});
		}

		this.ui = function () {
			this.parent = "";
			this.table = "";
			this.GUID = "";
		}

		this.GUID = function () {
			var id = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
				var r = Math.random() * 16 | 0, v = c == "x" ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			});
			return id;
		}

		this.RGB2HEX = function (c) {
			// Based on: http://haacked.com/archive/2009/12/29/convert-rgb-to-hex.aspx
			var m = /rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(c);
			return m ? "#" + (1 << 24 | m[1] << 16 | m[2] << 8 | m[3]).toString(16).substr(1) : c;
		}

		this.destroy = function () {
			var editor = tinyMCE.get("content1");
			var editorBody = editor.getBody();
			var editorContent = editor.getContent();
			var iframeElement = editor.iframeElement;
			var events = Storyboard.LayoutDesigner.UserEvents.getEventsOptions(designer);
			var currentBackgroundColor = editorBody.style.backgroundColor;
			var currentBackgroundColorId = editorBody.getAttribute("data-background-color-colorplaceholderid");
			var currentAlignVertical = editorBody.getAttribute("data-align-vertical");
			var currentAutoResize = editorBody.getAttribute("data-autoresize");

			var content = $("<div class=\"wrappertext\"></div>")
				.css("background-color", currentBackgroundColor)
				.append(editorContent);

			if (currentBackgroundColorId)
				content.attr("data-background-color-colorplaceholderid", currentBackgroundColorId);

			if (currentAlignVertical)
				content.attr("data-align-vertical", currentAlignVertical);

			if (currentAutoResize) {
				content.attr("data-autoresize", 'true');
				content.css("height", iframeElement.style.height);
			}

			if (events && events.length > 0) content.attr("data-user-events", events);

			if ($(".mce-btn.mce-active[aria-label='" + locale.get("Copy text style to all languages") + "']").length > 0) {
				content.attr("data-copy-style", true);
			} else {
				content.removeAttr("data-copy-style");
			}

			tinyMCE.activeEditor.remove();
			$(designer).html(content);
			$("#content1").detach();
			$("#statictext").empty().detach();
			$(designer).show().parent().show();
		}

		if (options === "destroy") {
			if (this.length === 1) {
				designer.destroy();
			}
		}
	}

	// Workaround for TinyMCE issue https://github.com/tinymce/tinymce/issues/2260
	window.tinymceListNodesCheck = function(ed) {
		ed.on('NodeChange', function (e) {
			var node = e.element;
			var closestLi = node.closest('LI');

			if (node.nodeName === 'SPAN' && closestLi && closestLi.textContent.trim() === '') {
				var fontSize = ed.dom.getStyle(node, 'font-size');
				var fontFamily = ed.dom.getStyle(node, 'font-family');
				var color = ed.dom.getStyle(node, 'color');
				var placeholderId = ed.dom.getAttrib(node, 'data-color-colorplaceholderid');

				if (fontSize) ed.dom.setStyle(closestLi, 'font-size', fontSize);
				if (fontFamily) ed.dom.setStyle(closestLi, 'font-family', fontFamily);
				if (color) ed.dom.setStyle(closestLi, 'color', color);
				if (placeholderId) ed.dom.setAttrib(closestLi, 'data-color-colorplaceholderid', placeholderId);
			}
		});

		ed.on('ExecCommand', function(evt) {
			var cmd = evt.command, val, node, listNode, closestLi, range, li, color, placeholderId, 
						currentColor, currentFontSize, currentFontFamily;

			if (cmd === 'FontSize' || cmd === 'FontName') {
				val = evt.value;
				node = evt.target.selection.getNode();
				closestLi = node.closest('LI');
				if (node.nodeName === 'SPAN' && closestLi) {
					currentFontSize = ed.dom.getStyle(findClosestElementWithStyle(closestLi.firstElementChild, 'fontSize'), 'font-size');
					currentFontFamily = ed.dom.getStyle(findClosestElementWithStyle(closestLi.firstElementChild, 'fontFamily'), 'font-family');
					if (cmd === 'FontSize' && currentFontSize === val) ed.dom.setStyle(closestLi, 'font-size', currentFontSize);
					else if (cmd === 'FontName' && currentFontFamily === val) ed.dom.setStyle(closestLi, 'font-family', currentFontFamily);
				} else if (node.nodeName === 'LI') {
					currentFontSize = ed.dom.getStyle(node.firstElementChild, 'font-size');
					currentFontFamily = ed.dom.getStyle(node.firstElementChild, 'font-family');
					if (cmd === 'FontSize' && currentFontSize === val) ed.dom.setStyle(node, 'font-size', val);
					else if (cmd === 'FontName' && currentFontFamily === val) ed.dom.setStyle(node, 'font-family', val);
				} else if (node.nodeName === 'UL' || node.nodeName === 'OL') {
					range = evt.target.selection.getRng();
					li = ed.dom.select('li', node);
					li = li.filter(function(liEl) { return range.intersectsNode(liEl); });
					if (cmd === 'FontSize') ed.dom.setStyle(li, 'font-size', val);
					else if (cmd === 'FontName') ed.dom.setStyle(li, 'font-family', val);
				}
			}

			if (evt.name === 'forecolor') {
				color = evt.vars.value;
				placeholderId = evt.vars.placeholderId;
				node = evt.target.selection.getNode();
				closestLi = node.closest('LI');
				if (node.nodeName === 'SPAN' && closestLi) {
					currentColor = ed.dom.getStyle(findClosestElementWithStyle(closestLi.firstElementChild, 'color'), 'color');
					if (tinycolor(currentColor).toHex() === tinycolor(color).toHex()) {
						ed.dom.setStyle(closestLi, 'color', color);
						if (placeholderId)
							ed.dom.setAttrib(closestLi, 'data-color-colorplaceholderid', placeholderId);
					}
				} else if (node.nodeName === 'LI') {
					currentColor = ed.dom.getStyle(node.firstElementChild, 'color');
					if (tinycolor(currentColor).toHex() === tinycolor(color).toHex()) {
						ed.dom.setStyle(node, 'color', color);
						if (placeholderId)
							ed.dom.setAttrib(node, 'data-color-colorplaceholderid', placeholderId);
					}
				} else if (node.nodeName === 'UL' || node.nodeName === 'OL') {
					range = evt.target.selection.getRng();
					li = ed.dom.select('li', node);
					li = li.filter(function(liEl) { return range.intersectsNode(liEl); });
					ed.dom.setStyle(li, 'color', color);
					if (placeholderId)
						ed.dom.setAttrib(li, 'data-color-colorplaceholderid', placeholderId);
				}
			}

			function findClosestElementWithStyle(elem, style, bottomUp) {
				while(elem) {
					if (elem) {
						if (elem.style[style]) {
							return elem;
						}
					}
					elem = bottomUp ? elem.parentElement : elem.firstElementChild;
				}
				return null;
			}

			if (cmd === 'InsertUnorderedList' || cmd === 'InsertOrderedList') {
				node = listNode = evt.target.selection.getNode();

				if (node.nodeName !== 'UL' && node.nodeName !== 'OL') {
					listNode = node.closest('li') ? node.closest('li').parentElement : node;
				}

				var listItems = listNode.children;

				for (var i = 0; i < listItems.length; i++) {
					var listItem = listItems[i];
					if (evt.target.selection.getContent() === '') {
						currentColor = findClosestElementWithStyle(node, 'color', true);
						currentFontSize = findClosestElementWithStyle(node, 'fontSize', true);
						currentFontFamily = findClosestElementWithStyle(node, 'fontFamily', true);
					} else {
						currentColor = findClosestElementWithStyle(listItem.firstElementChild, 'color');
						currentFontSize = findClosestElementWithStyle(listItem.firstElementChild, 'fontSize');
						currentFontFamily = findClosestElementWithStyle(listItem.firstElementChild, 'fontFamily');
					}

					if (currentColor) {
						color = ed.dom.getStyle(currentColor, 'color');
						placeholderId = ed.dom.getAttrib(currentColor, 'data-color-colorplaceholderid');
	
						if (color) {
							ed.dom.setStyle(listItem, 'color', color);
							if (placeholderId) {
								ed.dom.setAttrib(listItem, 'data-color-colorplaceholderid', placeholderId);
							}
						}
					}
	
					if (currentFontSize) {
						var fontSize = ed.dom.getStyle(currentFontSize, 'font-size');
						ed.dom.setStyle(listItem, 'font-size', fontSize);
					}

					if (currentFontFamily) {
						var fontFamily = ed.dom.getStyle(currentFontFamily, 'font-family');
						ed.dom.setStyle(listItem, 'font-family', fontFamily);
					}
				}
			}
		});
	}

	// Firefox 'arial black' font issue
	window.firefoxArialBlack = function (ed) {
		function applyFontsRecursive (node, fontFamily, fontWeight) {
			ed.dom.setStyle(node, 'font-weight', fontWeight);
			ed.dom.setStyle(node, 'font-family', fontFamily);

			var temp_array = [],
				length = node.children.length;
			for (var i = 0; i < length; i++) {
				temp_array.push(node.children[i]);
			}
			temp_array.forEach(function (item) {
				applyFontsRecursive(item, fontFamily, fontWeight);
			});
		}

		ed.on('ExecCommand', function (evt) {
			if (evt.command === 'FontName') {
				var val = evt.value;
				var node = evt.target.selection.getNode();
				if (evt.value === 'arial black') {
					applyFontsRecursive(node, "'arial black', arial", '900');
				} else {
					applyFontsRecursive(node, val, 'normal');
				}
			}
		});
	}
}(jQuery));

function fixdynamictext(paragraphs) {
	var dynamictextpattern = new RegExp("([\\[](Q[0-9]+|INT|TP|MA|VS|RD|HFILTER)[:][LO][:\\d:]*[\\]])");
	var specialtokenspattern = new RegExp("([\\[](PROJECT_NAME|REPORT_NAME|SLIDE_NAME|SLIDE_NO|DATE)[\\]])");

	// adding a new line and then removing it breaks dynamic text into two span elements
	// updateDynamicText() function doesn't recognize the html tags inside the dynamic text and skips it
	// broken dynamic text needs to be merged in one span for the update function to work

	$(paragraphs).each(function (i) {
		var spans = this.children;

		for (var j = 0; j < spans.length; j++) {
			var currentitem = spans[j];
			var nextitem = spans[j + 1];
			var currentcontent = $(currentitem).html();
			var nextcontent = $(nextitem).html();

			if (currentcontent.lastIndexOf('[') > currentcontent.lastIndexOf(']')) { // check if the current element contains unclosed dynamic text
				if (nextcontent != null && nextcontent.indexOf(']') >= 0) { // check if the next element exists (in case there were multiple new lines) and contains ']'
					var mergedcontent = currentcontent + nextcontent; // merge the content of the two elements

					if (dynamictextpattern.test(mergedcontent) || specialtokenspattern.test(mergedcontent)) { // test if merged content matches the dynamic/special pattern
						var dynamicendindex = nextcontent.indexOf(']');
						var dynamicend = nextcontent.substr(0, dynamicendindex + 1);
						$(currentitem).html(currentcontent + dynamicend); // move the missing part of the dynamic text to current element
						$(nextitem).html(nextcontent.substr(dynamicendindex + 1)); // remove part of the broken dynamic text from the next element
					}
				}
			}
		}
	});
}